import UserService from './UserService.js'
import ChallengeService from './ChallengeService.js'
import Keys from '../keys/keys.js';
import ga from 'analytics';

class PluginService {
    constructor()  {
        this.plugins = {}
        this.plugins["google_calendar"] = { // Calendar
            connect: function(plugin){
                sessionStorage.pluginId = plugin.id;
                window.location.assign('https://accounts.google.com/o/oauth2/auth?client_id=' + Keys.GOOGLE_CLIENT_KEY + '&redirect_uri=' + encodeURIComponent(Keys.GOOGLE_REDIRECT_URI) + '&scope=' + Keys.SCOPES_CAL.join(" ") + '&approval_prompt=force&response_type=code&access_type=offline')
                return Promise.resolve();
            },
            disconnect: function(plugin){
                return UserService.removeUserPlugin(plugin.id);
            }
        }

        this.plugins["google_calendar_v2"] = { // Calendar
            connect: function(plugin){
                sessionStorage.pluginId = plugin.id;
                window.location.assign('https://accounts.google.com/o/oauth2/auth?client_id=' + Keys.GOOGLE_CLIENT_KEY + '&redirect_uri=' + encodeURIComponent(Keys.GOOGLE_REDIRECT_URI) + '&scope=' + Keys.SCOPES_CAL_V2.join(" ") + '&approval_prompt=force&response_type=code&access_type=offline')
                return Promise.resolve();
            },
            disconnect: function(plugin){
                return UserService.removeUserPlugin(plugin.id);
            }
        }

        this.plugins["google_plus"] = { // Contacts
            connect: function(plugin){
                sessionStorage.pluginId = plugin.id;
                window.location.assign('https://accounts.google.com/o/oauth2/auth?client_id=' + Keys.GOOGLE_CLIENT_KEY + '&redirect_uri=' + encodeURIComponent(Keys.GOOGLE_REDIRECT_URI) + '&scope=' + Keys.SCOPES_GOOGLE_PEOPLE.join(" ") + '&approval_prompt=force&response_type=code&access_type=offline')
                return Promise.resolve();
            },
            disconnect: function(plugin){
                return UserService.removeUserPlugin(plugin.id);
            }
        }
        
        this.plugins["google_fit_web"] = {
            connect: function(plugin){
                sessionStorage.pluginId = plugin.id;
                window.location.assign('https://accounts.google.com/o/oauth2/auth?client_id=' + Keys.GOOGLE_CLIENT_KEY + '&redirect_uri=' + encodeURIComponent(Keys.GOOGLE_REDIRECT_URI) + '&scope=' + Keys.SCOPES_FIT.join(" ") + '&approval_prompt=force&response_type=code&access_type=offline')
                return Promise.resolve();
            },
            disconnect: function(plugin){
                return UserService.removeUserPlugin(plugin.id);
            }
        }

        this.plugins['validic_client_sync_url'] = {
            connect: function(plugin){
                return UserService.fetchPluginSyncUrl(plugin.id, Keys.VALIDIC_REDIRECT_URI).then(function(result) {
                    if(!result || !result.plugin || !result.plugin.syncUrl) {
                        console.error('fetchPluginSyncUrl - result.plugin.syncUrl missing. result=', result);
                        throw new Error('fetchPluginSyncUrl - result.plugin.syncUrl missing.');
                    }
                    window.location.assign(result.plugin.syncUrl)
                    return Promise.resolve();
                })
            },

            disconnect: function(plugin){
                return UserService.fetchPluginSyncUrl(plugin.id).then(function(result) {
                    console.log('PluginService.pluginsvalidic_healthgraph.disconnect, result: ', result);
                    if(!result || !result.plugin || !result.plugin.unsyncUrl) 
                        return;

                    return fetch(result.plugin.unsyncUrl,{ method: 'GET' });

                })
            }
        }


    }

    getDriver(plugin) {
        var tagId = plugin.tag;
        var pluginDriver =  this.plugins[tagId];
        if (pluginDriver==null && plugin.clientSyncUrl===true) {
            pluginDriver = this.plugins.validic_client_sync_url;
        }
        return pluginDriver;
    }

    connect(plugin) {
        console.log("PluginService.connect: ", plugin);
        ga('send', 'event', {
            eventCategory: 'oAuth',
            eventAction: 'connect - '+plugin.tag,
            eventLabel: 'connect'
          });
        var pluginDriver =  this.getDriver(plugin);
        if(pluginDriver) {
           return pluginDriver.connect(plugin);
        }else {
            console.error('PluginService.connect - unsupported plugin');
            window.alert('PluginService.connect - unsupported plugin');
            return Promise.resolve(false);
        }
    }

    disconnect(plugin) {
        console.log("PluginService.disconnect: ", plugin)
        ga('send', 'event', {
            eventCategory: 'oAuth',
            eventAction: 'disonnect - '+plugin.tag,
            eventLabel: 'disonnect'
          });
        var pluginDriver =  this.getDriver(plugin);
        if(pluginDriver) {
            return pluginDriver.disconnect(plugin);
        } else {
            console.error('PluginService.disconnect - unsupported plugin');
            window.alert('PluginService.disconnect - unsupported plugin');
            return Promise.resolve(false);
        }
    }
    
}


export default new PluginService();




// WEBPACK FOOTER //
// ./src/services/PluginService.js